import styled from "styled-components";
import { MainContainer } from "Themes/StyledComponents";

export const Container = styled(MainContainer)``;
